import { BbMacrosService } from 'app/services/bb-macros.service';
import { Subscription } from 'rxjs';
import { BbSelectOption } from 'app/components/shared/bb-select/bb-select.component';
import { MatOption } from '@angular/material/core';
import { BbEntitySelectorComponent } from 'app/components/shared/bb-entity-selector/bb-entity-selector.component';
import { Component, Input, OnInit, HostBinding, ViewChild, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'bb-macro-suggestions',
	templateUrl: './bb-macro-suggestions.component.html',
	styleUrls: ['./bb-macro-suggestions.component.scss']
})
export class BbMacroSuggestionsComponent implements OnInit, OnDestroy {
	@HostBinding('class.active') get isActive() {
		return this.active;
	}
	@Input() theme: 'light-v2' | 'dark' = 'light-v2';
	@Input() active: boolean;
	@Input() macroSuggestions = [];
	@Output() selected: EventEmitter<any> = new EventEmitter<any>();
	@HostBinding('class.dark-mode') get isDarkMode() {
		return this.theme === 'dark';
	}

	@ViewChild('suggestionES') suggestionES: BbEntitySelectorComponent;

	filteredAutoCompleteOptions: MatOption[];
	suggestOptions: BbSelectOption[];
	suggestionsOpen = false;
	macroSubscription: Subscription;

	constructor(
		private el: ElementRef,
		public bbMacrosService: BbMacrosService,
	) {

	}

	ngOnInit(): void {
		this.initMacroSuggestions();
	}

	ngOnDestroy() {
		if (this.macroSubscription) {
			this.macroSubscription.unsubscribe();
		}
	}

	// Insert macro's
	showSuggestions(keyUsed?: string) {
		this.suggestionsOpen = true;
		if (this.suggestionES) {
			this.suggestionES.open();
		}
	}

	onSuggestionsButtonClick() {
		if (this.suggestionsOpen) {
			this.suggestionsOpen = false;
		} else {
			this.showSuggestions();
		}
	}

	initMacroSuggestions() {
		if (!this.macroSubscription) {
			this.macroSubscription = this.bbMacrosService.macroSubject.subscribe((macroOptions) => {
				this.suggestOptions = macroOptions;
			});
		}
	}

	suggestionSelected(suggestOption: any) {
		this.selected.emit(suggestOption);
		this.suggestionsOpen = false;
	}

}
